
(function () {
  'use strict';

  const THRESHOLD = 5900;
  let timer;

  async function updateShippingProgress() {
    const bar = document.getElementById('RdShippingProgress');
    if (!bar) return;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {
        cache: 'no-store'
      });

      if (!response.ok) return;

      const cart = await response.json();
      const total = cart.total_price;
      const remaining = Math.max(0, THRESHOLD - total);
      const percentage = Math.min(100, total / THRESHOLD * 100);

      const message = bar.querySelector('#RdShippingMessage');
      const fill = bar.querySelector('#RdShippingFill');

      if (!message || !fill) return;

      fill.style.width = percentage + '%';

      if (remaining === 0) {
        message.textContent = '✓ Hai sbloccato la spedizione gratuita!';
        bar.classList.add('is-complete');
      } else {
        const amount = (remaining / 100).toLocaleString('it-IT', {
          style: 'currency',
          currency: 'EUR'
        });

        message.textContent =
          'Ti mancano ' + amount + ' per la spedizione gratuita!';
        bar.classList.remove('is-complete');
      }
    } catch (error) {
      console.warn('RD shipping progress:', error);
    }
  }

  function scheduleUpdate() {
    clearTimeout(timer);
    timer = setTimeout(updateShippingProgress, 350);
  }

  function init() {
    updateShippingProgress();

    const products = document.querySelector(
      '#CartDrawer [data-products]'
    );

    if (products) {
      const observer = new MutationObserver(scheduleUpdate);

      observer.observe(products, {
        childList: true,
        subtree: false
      });
    }

    document.addEventListener('cart:updated', scheduleUpdate);
    document.addEventListener('cart:build', scheduleUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
